/**
 * Commerce7 Card - Variant popup handle
 */

export default function C7Card() {
	const selectors = {
		giftCard: ".c7-product--gift-card",
		variantPrice: ".c7-product__variant__price",
		variantSelect: ".c7-product__variant__select",
		addtoCartBtn: ".c7-product__variant__add-to-cart:last-child",
		addtoCartForm: ".c7-product__variant",
		giftMessage: ".c7-product__variant__gift-card:last-child",
	};

	this.init = () => {
		c7.addAction("c7_collection_products_rendered", (collection) => {
			createGiftCardPopup(collection);
		});
	};

	/**
	 * Search gift card and make add popup classes
	 *
	 * @param {Node} collection
	 */
	const createGiftCardPopup = (collection) => {
		collection.querySelectorAll(selectors.giftCard).forEach((card) => {
			const addtoCartBtn = card.querySelector(selectors.addtoCartBtn);

			// Add class to the div containing inputs.
			const toWrap = addtoCartBtn.previousElementSibling;
			toWrap.classList.add("c7-product__variant__inputs-wrapper");

			// Create a popup.
			const form = card.querySelector(selectors.addtoCartForm);
			const popup = document.createElement("div");
			popup.classList.add("c7-product__variant__popup");
			form.appendChild(popup);

			// Popup gift message.
			const giftMessageBox = card.querySelector(selectors.giftMessage);
			if (giftMessageBox) {
				giftMessageBox.innerHTML = '<label for="c7-giftMessage">Gift Message:<br><i>Be sure to sign your name so they know who its from.</i><textarea id="c7-giftMessage" name="giftMessage"></textarea></label>';
				toWrap.appendChild(giftMessageBox);
				popup.appendChild(toWrap);
			}

			// Popup close button.
			popup.innerHTML = '<div class="icon-close"></div>';
			const close = popup.querySelector(".icon-close");
			close.onclick = popupCloseHandler;
			toWrap.appendChild(close);
			popup.appendChild(toWrap);

			// Add a new button to trigger popup.
			const newBtn = addtoCartBtn.cloneNode();
			newBtn.classList.add("cloned");
			newBtn.innerHTML = "Add to Cart";
			card.querySelector(selectors.addtoCartForm).appendChild(newBtn);
			newBtn.onclick = addToCartHandler;

			// Add a new button to the popup.
			const popupBtn = newBtn.cloneNode();
			popupBtn.innerHTML = "Add to Cart";
			toWrap.appendChild(popupBtn);
			popupBtn.onclick = inputsValidate;
		});

		collection.querySelectorAll(selectors.addtoCartForm).forEach((card) => {
			// Remove variant price if variant select option is available.
			if (card.querySelector(selectors.variantSelect)) {
				card.querySelector(selectors.variantPrice).remove();
			}
		});
	};

	/**
	 * Gift card add to cart button click handler.
	 *
	 * Show popup that contains the recipient email and message inputs.
	 */
	const addToCartHandler = function (e) {
		e.preventDefault();
		const form = this.parentElement;
		form.classList.add("popup");
	};

	const popupCloseHandler = function () {
		const form = this.parentElement.parentElement.parentElement;
		form.classList.remove("popup");
	};

	const inputsValidate = function (e) {
		e.preventDefault();
		const inputsWrapper = this.parentElement;
		const email = inputsWrapper.querySelector("[name=email]");
		if (!email.value) {
			if (inputsWrapper.querySelector(".c7-product__error")) {
				return;
			}
			const error = document.createElement("div");
			error.innerHTML =
				'<div class="c7-product__error" aria-describedby="qtyerror">Error: Recipient Email Rquired</div>';
			inputsWrapper.insertBefore(error, this);
		} else {
			const form = inputsWrapper.parentElement.parentElement;
			form.classList.remove("popup");
			form.querySelector(".c7-button").click();
		}
	};
}
